module.exports = __webpack_public_path__ + "static/media/edit-canvas-dark.a4ff4535.svg";